import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { defaultTemplate } from 'core/hoc';
import { BaasicTableLoader } from 'core/components';
import { Grid, GridNoRecords } from '@progress/kendo-react-grid';
import {
    getSortingParams,
    getPagingProps,
    defaultRenderActions,
    defaultRenderColumns,
    defaultRenderNoRecords,
    defaultRenderBatchActionsToolbar,
} from 'core/components/table/utils';
import PagerTemplate from './PagerTemplate';

const BaasicTableTemplate = function({ tableStore, loading, actionsComponent, actionHeaderComponent, noRecordsComponent, customRow, authorization, t,...otherProps }) {
    const {isBatchSelect, data, config: { columns, actions, actionsWidth, onRowClick, ...otherStoreFields } } = tableStore;
    const isLoading = !_.isNil(loading) ? loading : tableStore.loading;
    // v3-5 rendered a `detail` row always inline with no expander column. v14 always
    // injects a hierarchy/expand column and starts detail rows collapsed. For the plain
    // customRow use (always-visible sub-row, no toggle) keep every row expanded via the
    // controlled detailExpand descriptor and hide the expander column in CSS.
    // Memoise the descriptor so its reference stays stable across unrelated re-renders and
    // only changes when `data` is reassigned (setData/updateDataItems). A fresh object every
    // render would make Kendo re-derive/reconcile the detail rows on each pass.
    const hasCustomRow = !!customRow;
    const detailExpand = React.useMemo(
        () => hasCustomRow
            ? data.reduce((acc, item) => { if (item && item.id != null) acc[item.id] = true; return acc; }, {})
            : undefined,
        [hasCustomRow, data]
    );
    return (
        <div className={hasCustomRow ? 'baasic-table baasic-table--inline-detail' : 'baasic-table'}>
            <Grid
                data={data.slice()}
                detail={customRow}
                pager={PagerTemplate}
                {...otherProps}
                {...otherStoreFields}
                {...getSortingParams(tableStore)}
                {...getPagingProps(tableStore)}
                {...(hasCustomRow ? { dataItemKey: 'id', detailExpand } : {})}
                onRowClick= {onRowClick ? (item) => onRowClick(item.dataItem) : () => {}}
                >
                {
                    <GridNoRecords>
                        {isLoading ? 'Loading...' : defaultRenderNoRecords(noRecordsComponent)}
                    </GridNoRecords>
                }
                {isBatchSelect ? defaultRenderBatchActionsToolbar(tableStore, authorization) : null}
                {defaultRenderColumns({ t, columns})}
                {defaultRenderActions({ actions, actionsComponent, actionsWidth, authorization, t, actionHeaderComponent })}
            </Grid>
            {isLoading ? <BaasicTableLoader /> : null}
        </div>
    )
};

BaasicTableTemplate.propTypes = {
    tableStore: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    actionsComponent: PropTypes.any,
    actionHeaderComponent: PropTypes.any,
    noRecordsComponent: PropTypes.any,
    scrollable: PropTypes.string,
    editField: PropTypes.string,
    authorization: PropTypes.any,
    t: PropTypes.func,
    customRow: PropTypes.any,
};

BaasicTableTemplate.defaultProps = {
    scrollable: 'none'
};

export default defaultTemplate(BaasicTableTemplate);
